import { cookieRef } from "@layouts/stores/config"
import { themeConfig } from "@themeConfig"
import { createI18n } from "vue-i18n"

// Helper function to check if item is an object
const isObject = item => item && typeof item === 'object' && !Array.isArray(item)

// Deep merge helper
const mergeDeep = (target, ...sources) => {
  if (!sources.length) return target
  const source = sources.shift()

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} })
        mergeDeep(target[key], source[key])
      } else {
        Object.assign(target, { [key]: source[key] })
      }
    }
  }

  return mergeDeep(target, ...sources)
}

// 1. Mevcut locales klasöründeki dosyaları al
const defaultMessages = Object.fromEntries(
  Object.entries(import.meta.glob('./locales/*.json', { eager: true })).map(
    ([key, value]) => [key.slice(10, -5), value.default],
  ),
)

// 2. Views ve components altındaki locales dosyalarını al (@/views/**/locales/*.json ve @/aygulyazilim/components/**/locales/*.json)
const viewMessages = Object.entries(import.meta.glob(['@/views/**/locales/*.json', '@/aygulyazilim/components/**/locales/*.json'], { eager: true })).reduce((acc, [path, value]) => {
  const match = path.match(/([\w-]+)\.json$/)
  if (match) {
    const locale = match[1]
    if (!acc[locale]) acc[locale] = {}
    
    mergeDeep(acc[locale], value.default)
  }
  
  return acc
}, {})

// 3. Hepsini birleştir
const messages = mergeDeep({}, defaultMessages, viewMessages)

let _i18n = null
export const getI18n = () => {
  if (_i18n === null) {
    _i18n = createI18n({
      legacy: false,
      locale: cookieRef("language", themeConfig.app.i18n.defaultLocale).value,
      fallbackLocale: "tr",
      messages,
      missing: (locale, key) => {
        // Sadece development ortamında çalış
        if (import.meta.env.MODE === "development") {
          // eksik anahtar burada yakalanır
        }
      },
    })
  }

  return _i18n
}

export default function (app) {
  const i18n = getI18n()

  app.use(i18n)
}
